import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionKicker } from "./Reveal";

export const HowWeWork = () => {
  const { t } = useLang();
  const h = t.how;

  return (
    <section
      id="como-trabajamos"
      data-testid="how-section"
      className="py-24 sm:py-32 bg-[#050505]"
    >
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <SectionKicker>{h.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {h.title}
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute top-7 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            {h.steps.map((step, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative" data-testid={`how-step-${i}`}>
                  <div className="h-14 w-14 rounded-full bg-[#0d0d0d] border-2 border-brand grid place-items-center font-heading text-xl font-bold text-brand relative z-10">
                    {i + 1}
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-white">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
